<script lang="ts">
    import Fa from 'svelte-fa'
    import { faPencil, faPlusCircle, faTrash } from '@fortawesome/free-solid-svg-icons'
    import { onMount } from 'svelte/internal'
    import Content from '../_common/content.svelte'
    import LoadSpinner from '../_common/load-spinner.svelte'
    import Zgrid from '../_common/z/zgrid.svelte'
    import Zact from '../_common/z/zact.svelte'
    import Zbutton from '../_common/z/zbutton.svelte'
    import { GridButton, GridClass, GridCol, GridColTypeEnum, GridLine, GridToggle } from '../_common/z/zgrid'
    import Ztab from '../_common/z/ztab.svelte'
    import FormBuilder from './builder/form-builder.svelte'
    import { createDefaultHeaderFooter } from './types/document-header-footer'
    import type { FormV2Template } from '../../modules/toolsApi/forms-v2/form-v2-templates/form-v2-template'

    const tabs = [{ title: 'Formulários', url: () => {} }]
    let activeTab = 'Formulários'

    let step = 1
    let show = false
    let entities: Pick<FormV2Template, 'formV2TemplateId' | 'title' | 'status' | 'updatedAt' | 'createdAt'>[] = []
    let selected: FormV2Template | null = null
    let grid: GridClass = new GridClass()

    onMount(async () => {
        await loadEntities()
    })

    async function loadEntities() {
        try {
            show = true
            entities = await window.api.tools.formsV2.formTemplates.getAll()
            loadGrid()
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }

    async function toggleStatus(id: string) {
        const current = entities.find((el) => el.formV2TemplateId === id)
        await window.api.tools.formsV2.formTemplates.update(id, { status: current.status === 100 ? 70 : 100 })
        await loadEntities()
    }

    function loadGrid() {
        grid = new GridClass()
        grid.title = 'Modelos de Formulários'
        grid.cols.push(new GridCol({ content: 'Ativo', type: GridColTypeEnum.toggle, size: 1 }))
        grid.cols.push(new GridCol({ content: 'Título' }))
        grid.cols.push(new GridCol({ content: 'Última edição', size: 2, type: GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))

        for (const item of entities) {
            const toggle = new GridToggle({
                checked: item.status === 100,
                callback: () => toggleStatus(item.formV2TemplateId),
            })
            const line = new GridLine()
            line.slots.push({ content: toggle })
            line.slots.push({ content: item.title })
            line.slots.push({ content: item.updatedAt })
            line.slots.push({
                content: [
                    new GridButton({ icon: faPencil, label: 'Editar', callback: () => openEdit(item.formV2TemplateId) }),
                    new GridButton({ icon: faTrash, label: 'Excluir', callback: () => removeEntity(item.formV2TemplateId) }),
                ],
            })
            grid.lines.push(line)
        }
    }

    function openNew() {
        selected = null
        step = 2
    }

    async function openEdit(id: string) {
        try {
            show = true
            selected = await window.api.tools.formsV2.formTemplates.getOne(id)
            step = 2
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }

    async function removeEntity(id: string) {
        if (!confirm('Deseja mesmo excluir este formulário?')) return
        try {
            show = true
            await window.api.tools.formsV2.formTemplates.remove(id)
            await loadEntities()
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }

    async function onBack() {
        step = 1
        selected = null
        await loadEntities()
    }
</script>

<div class="root-content">
    <Ztab class="h-space" {tabs} active={activeTab} />
    <Content footer={false}>
        {#if step === 1}
            <Zact>
                <div class="spacer" />
                <Zbutton color="primary" icon={faPlusCircle} label="Novo modelo" mobileHideLabel={true} on:click={openNew} />
            </Zact>
            <Zgrid {grid} class="h-space mb-6" />
        {:else}
            <FormBuilder
                formV2TemplateId={selected?.formV2TemplateId ?? null}
                initialTitle={selected?.title ?? ''}
                initialCategory={selected?.category ?? 'outro'}
                initialRequiredFields={selected?.requiredFields ?? []}
                initialBlocks={selected?.document?.blocks ?? []}
                initialHeaderFooter={selected?.document?.headerFooter ?? createDefaultHeaderFooter()}
                on:back={onBack}
            />
        {/if}
        <LoadSpinner {show} />
    </Content>
</div>
